export default {
    categories: {
        contact: {
            title: window.i18n.__('Contact'),
            subtitle: window.i18n.__('Données contact'),
        },
    },
    rows: [
        {
            category: 'contact',
            label: window.i18n.__('Identifiant contact'),
            description: {
                text: window.i18n.__('Récupéré uniquement depuis un export Sellsy'),
                subtext: window.i18n.__('Utile uniquement en cas de mise à jour'),
            },
            mandatory: false,
            value: {
                text: window.i18n.__('Numérique'),
            },
        },
        {
            category: 'contact',
            label: window.i18n.__('Civilité contact'),
            description: {
                text: window.i18n.__('Civilité du contact'),
            },
            mandatory: false,
            value: {
                text: window.i18n.__('Alphanumérique'),
            },
        },
        {
            category: 'contact',
            label: window.i18n.__('Nom contact'),
            description: {
                text: window.i18n.__('Nom de famille du contact'),
            },
            mandatory: true,
            value: {
                text: window.i18n.__('Alphanumérique'),
            },
        },
        {
            category: 'contact',
            label: window.i18n.__('Prénom contact'),
            description: {
                text: window.i18n.__('Prénom du contact'),
            },
            mandatory: false,
            value: {
                text: window.i18n.__('Alphanumérique'),
            },
        },
        {
            category: 'contact',
            label: window.i18n.__('Email contact'),
            description: {
                text: window.i18n.__('Adresse email du contact'),
            },
            mandatory: false,
            value: {
                text: window.i18n.__('Adresse email'),
            },
        },
        {
            category: 'contact',
            label: window.i18n.__('Téléphone contact'),
            description: {
                text: window.i18n.__('Numéro de téléphone fixe du contact'),
            },
            mandatory: false,
            value: {
                text: window.i18n.__('Téléphone au format international ou national'),
                subtext: window.i18n.__('+33xxxxxxxxx ou 0234567890'),
            },
        },
        {
            category: 'contact',
            label: window.i18n.__('Mobile contact'),
            description: {
                text: window.i18n.__('Numéro de téléphone mobile du contact'),
            },
            mandatory: false,
            value: {
                text: window.i18n.__('Téléphone au format international ou national'),
                subtext: window.i18n.__('+33xxxxxxxxx ou 0234567890'),
            },
        },
        {
            category: 'contact',
            label: window.i18n.__('Fax contact'),
            description: {
                text: window.i18n.__('Numéro de fax du contact'),
            },
            mandatory: false,
            value: {
                text: window.i18n.__('Téléphone au format international ou national'),
                subtext: window.i18n.__('+33xxxxxxxxx ou 0234567890'),
            },
        },
        {
            category: 'contact',
            label: window.i18n.__('Site internet contact'),
            description: {
                text: window.i18n.__('URL du site internet du contact'),
            },
            mandatory: false,
            value: {
                text: window.i18n.__('Alphanumérique'),
            },
        },
        {
            category: 'contact',
            label: window.i18n.__('Fonction contact'),
            description: {
                text: window.i18n.__('Fonction du contact'),
            },
            mandatory: false,
            value: {
                text: window.i18n.__('Alphanumérique'),
            },
        },
        {
            category: 'contact',
            label: window.i18n.__('Smart-tags'),
            description: {
                text: window.i18n.__('Liste de smart-tags'),
            },
            mandatory: false,
            value: {
                text: window.i18n.__('Alphanumérique'),
                subtext: window.i18n.__('À séparer par une virgule'),
            },
        },
        {
            category: 'contact',
            label: window.i18n.__('Propriétaire'),
            description: {
                text: window.i18n.__('Propriétaire du société'),
            },
            mandatory: false,
            value: {
                text: window.i18n.__('Nom complet du propriétaire du contact importé'),
            },
        },
        {
            category: 'contact',
            label: window.i18n.__('Note contact'),
            description: {
                text: window.i18n.__('Contenu affiché dans le champ note de la fiche contact'),
            },
            mandatory: false,
            value: {
                text: window.i18n.__('Alphanumérique'),
            },
        },
        {
            category: 'contact',
            label: window.i18n.__('Inscrit campagnes email contact'),
            description: {
                text: window.i18n.__('Détermine si le contact est inscrit aux campagnes email'),
            },
            mandatory: false,
            value: {
                text: window.i18n.__('“Y” pour oui ou “N” pour non'),
            },
        },
        {
            category: 'contact',
            label: window.i18n.__('Inscrit campagnes SMS contact'),
            description: {
                text: window.i18n.__('Détermine si le contact est inscrit aux campagnes SMS'),
            },
            mandatory: false,
            value: {
                text: window.i18n.__('“Y” pour oui ou “N” pour non'),
            },
        },
        {
            category: 'contact',
            label: window.i18n.__('Inscrit campagnes téléphonique contact'),
            description: {
                text: window.i18n.__(
                    'Détermine si le contact est inscrit aux campagnes téléphoniques',
                ),
            },
            mandatory: false,
            value: {
                text: window.i18n.__('“Y” pour oui ou “N” pour non'),
            },
        },
        {
            category: 'contact',
            label: window.i18n.__('Inscrit campagnes courrier contact'),
            description: {
                text: window.i18n.__('Détermine si le contact est inscrit aux campagnes courrier'),
            },
            mandatory: false,
            value: {
                text: window.i18n.__('“Y” pour oui ou “N” pour non'),
            },
        },
        {
            category: 'contact',
            label: window.i18n.__('Inscrit campagnes marketing personnalisé contact'),
            description: {
                text: window.i18n.__(
                    'Détermine si le contact est inscrit aux campagnes marketing personnalisées',
                ),
            },
            mandatory: false,
            value: {
                text: window.i18n.__('“Y” pour oui ou “N” pour non'),
            },
        },
        {
            category: 'contact',
            label: window.i18n.__('Contact archivé'),
            description: {
                text: window.i18n.__('Archiver ou non le contact'),
            },
            mandatory: false,
            value: {
                text: window.i18n.__('“Y” pour oui ou “N” pour non'),
            },
        },
    ],
};
